import { URL } from "../../config";

export const userToken = URL.user_token;
